import React, { useState } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";
import "./contactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    company: "",
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const response = await fetch("https://formspree.io/f/xdkenvpw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    setIsSubmitting(false);

    if (response.ok) {
      alert("Thank you! Your message has been sent successfully.");
      setFormData({ company: "", name: "", email: "", phone: "", message: "" });
    } else {
      alert("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <div className="contact-us">
      <h2 className="contact-title">Contact Us</h2>
      
      <div className="contact-container">
        <div className="contact-left">
          <h3>Get in Touch</h3>
         <p> Feel free to contact us if you have any questions. Our team is ready to assist you!</p>
                    <p><FaMapMarkerAlt className="contact-icon" /> <strong>Address:</strong> Jl. Rotan 1 RT 02 RW 01, Limo, Depok, Jawa Barat, Indonesia, 16531.</p>
          <p><FaEnvelope className="contact-icon" /> <strong>Email:</strong> headoffice@mars-ap.com</p>
          <p><FaPhone className="contact-icon" /> <strong>Phone:</strong> (+62) 877 7070 1099</p>

          <div className="map-container">
            <iframe
              title="Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.170322608793!2d106.77052061176938!3d-6.371999393591585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69eed82ef1ca09%3A0x5336076b3aea144c!2sJl.%20Limo%20Raya%20No.1%2C%20Limo%2C%20Kec.%20Limo%2C%20Kota%20Depok%2C%20Jawa%20Barat%2016514!5e0!3m2!1sid!2sid!4v1740648996113!5m2!1sid!2sid"
              width="100%"
              height="250"
              style={{ border: "0", borderRadius: "20px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          <div className="social-media">
            <h3>Follow Us</h3>
              <a href="https://www.instagram.com/yourusername" className="social-icon"><FaInstagram /></a>
              <a href="https://www.linkedin.com/in/yourusername" className="social-icon"><FaLinkedin /></a>
              <a href="https://www.facebook.com/@yourusername" className="social-icon"><FaFacebook /></a>
          </div>
        </div>

        <div className="contact-right">
          <h3>Send Us a Message</h3>
          <form onSubmit={handleSubmit}>  
            <input type="text" name="company" placeholder="Company Name" value={formData.company} onChange={handleChange} />
            <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
            <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
            <textarea name="message" placeholder="Your Requirement" value={formData.message} onChange={handleChange} required></textarea>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
